import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, Users, Phone, Mail, MapPin, Globe } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export default function MobileCRMCustomerDetailPage() {
  const { custId } = useParams();
  const navigate = useNavigate();
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Try direct lookup first, then fallback to list search
    axios.get(`${API}/crm/customers/${custId}`).then(r => setCustomer(r.data)).catch(() => {
      axios.get(`${API}/crm/customers`).then(r => {
        const found = (r.data || []).find(c => (c.customer_id || c.id) === custId);
        setCustomer(found || null);
      }).catch(() => {});
    }).finally(() => setLoading(false));
  }, [custId]);

  if (loading) return <div className="mobile-page"><div className="mobile-loading"><div className="mobile-spinner" /></div></div>;
  if (!customer) return <div className="mobile-page"><button className="mobile-back-btn" onClick={() => navigate(-1)}><ArrowLeft size={18} /> Back</button><div className="mobile-empty-state"><p>Customer not found</p></div></div>;

  const contacts = customer.contacts || [];

  return (
    <div className="mobile-page">
      <button className="mobile-back-btn" onClick={() => navigate('/mobile/crm/customers')}><ArrowLeft size={18} /> Customers</button>
      <div className="mobile-detail-section" style={{ textAlign: 'center', paddingTop: 20, paddingBottom: 20 }}>
        <div style={{ width: 56, height: 56, borderRadius: 28, background: '#34c759', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 10px', color: 'white', fontSize: 22, fontWeight: 700 }}>{(customer.company_name || customer.name || 'C')[0]}</div>
        <div style={{ fontSize: 20, fontWeight: 700, color: '#1c1c1e' }}>{customer.company_name || customer.name}</div>
        <div style={{ display: 'flex', gap: 6, justifyContent: 'center', marginTop: 8 }}>
          <span className={`mobile-status-badge ${customer.status === 'active' || customer.status === 'Active' ? 'in_production' : 'scheduled'}`}>{customer.status || 'Active'}</span>
          {customer.industry && <span className="mobile-status-badge staged">{customer.industry}</span>}
        </div>
      </div>
      <div className="mobile-detail-section">
        <div className="mobile-detail-section-title">Contact Info</div>
        {customer.phone && <div className="mobile-detail-row"><span className="mobile-detail-label"><Phone size={12} style={{ display: 'inline', verticalAlign: -1, marginRight: 4 }} />Phone</span><span className="mobile-detail-value">{customer.phone}</span></div>}
        {customer.email && <div className="mobile-detail-row"><span className="mobile-detail-label"><Mail size={12} style={{ display: 'inline', verticalAlign: -1, marginRight: 4 }} />Email</span><span className="mobile-detail-value">{customer.email}</span></div>}
        {customer.location && <div className="mobile-detail-row"><span className="mobile-detail-label"><MapPin size={12} style={{ display: 'inline', verticalAlign: -1, marginRight: 4 }} />Location</span><span className="mobile-detail-value">{customer.location}</span></div>}
        {customer.website && <div className="mobile-detail-row"><span className="mobile-detail-label"><Globe size={12} style={{ display: 'inline', verticalAlign: -1, marginRight: 4 }} />Website</span><span className="mobile-detail-value">{customer.website}</span></div>}
        {customer.notes && <div className="mobile-detail-row"><span className="mobile-detail-label">Notes</span><span className="mobile-detail-value" style={{ maxWidth: '60%', textAlign: 'right' }}>{customer.notes}</span></div>}
      </div>
      {contacts.length > 0 && (
        <div className="mobile-detail-section">
          <div className="mobile-detail-section-title">Contacts ({contacts.length})</div>
          {contacts.map((c, i) => (
            <div key={i} style={{ padding: '10px 0', borderBottom: i < contacts.length - 1 ? '1px solid #f2f2f7' : 'none' }}>
              <div style={{ fontWeight: 600, fontSize: 14, color: '#1c1c1e' }}>{c.name}</div>
              <div style={{ fontSize: 12, color: '#636366' }}>{c.title || ''}{c.email ? ` · ${c.email}` : ''}{c.phone ? ` · ${c.phone}` : ''}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
